"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Page = function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
  }

  _createClass(Page, [{
    key: "renderPage",
    value: function renderPage() {
      var _this2 = this;

      var _props$page = this.props.page,
          key = _props$page.key,
          file = _props$page.file;

      file.getPage(key).then(function (page) {
        // Prepare canvas using PDF page dimensions
        var canvas = _reactDom2.default.findDOMNode(_this2.refs["canvas"]);
        if (!canvas) return;
        var width = canvas.clientWidth;

        // Figure out page scale using known width
        var scale = width / page.getViewport(1).width;
        var pixelScale = window.devicePixelRatio || 1; // for retina
        var viewport = page.getViewport(scale * pixelScale);
        var height = width * (viewport.height / viewport.width);

        if (typeof _this2.props.onSizeReady === "function") _this2.props.onSizeReady(width, height);

        var context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        page.render(renderContext);
      }).catch(function (error) {
        throw error;
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderPage();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          style = _props.style,
          className = _props.className;

      return _react2.default.createElement("canvas", {
        className: className,
        style: _extends({}, style, { width: "100%", height: "auto", display: "block" }),
        ref: "canvas"
      });
    }
  }]);

  return Page;
}(_react.Component);

Page.propTypes = {
  page: _propTypes2.default.shape({
    key: _propTypes2.default.number.isRequired,
    file: _propTypes2.default.shape({
      getPage: _propTypes2.default.func.isRequired
    })
  }).isRequired
};
exports.default = Page;


//////////////////
// WEBPACK FOOTER
// ../~/react-pdf-pages/lib/Page.js
// module id = 2814
// module chunks = 2